var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.905899 6.06192L18.2148 0.0742927C18.917 -0.168617 19.6832 0.203699 19.9261 0.905882C20.0246 1.19082 20.0246 1.5006 19.9261 1.78554L13.9383 19.0941C13.6954 19.7963 12.9293 20.1686 12.2271 19.9257C11.8363 19.7905 11.5294 19.4831 11.3948 19.0921L9.13674 12.5319C8.8671 11.7485 8.2516 11.1331 7.46821 10.8634L0.907876 8.60544C0.205303 8.36362 -0.16821 7.59805 0.0736117 6.89549C0.208192 6.5045 0.515107 6.19711 0.905899 6.06192Z",
    fill: "#815FF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.61a8a9d36906c0716e8dd968d4d31a18.svg";
export { ForwardRef as ReactComponent };